import { render, staticRenderFns } from "./KawasanView.vue?vue&type=template&id=7cc949c4&scoped=true"
import script from "./KawasanView.vue?vue&type=script&lang=js"
export * from "./KawasanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc949c4",
  null
  
)

export default component.exports